module.exports = require("@ember/helper");